export default {"src":"/_next/static/media/frame6.3b7f64ae.svg","height":109,"width":236,"blurWidth":0,"blurHeight":0};